module.exports = __webpack_public_path__ + "media/images/front/premium_lp/point03/th_01-ad4cd93f386943b4b66f950905180272.jpg";